import React from 'react'
import { Button } from 'react-bootstrap'

export const ExchangeRatesView = (props) => {
    return <div>
        <select value={props.currencyPair} onChange={props.onSelectCurrencyPair}>
            <option value='GBP-EU'>GBP-EU</option>
            <option value='GBP-USD'>GBP-USD</option>
            <option value='GBP-CAD'>GBP-CAD</option>
            <option value='GBP-AUD'>GBP-AUD</option>
        </select>

        <div>
            <input value={props.currencyValue} onChange={(e) => props.onChangeCurrencyValue(e)}>{props.currencyValue}</input>
        </div>
        <Button onClick={props.onSubmit}>
            Add rate
        </Button>

    </div>
}